import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";




class NosMissions extends Component {
  render() {
    return (
    <div>   
   <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center">
                      <div className="col-md-8">
                    <h3><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Accompagnement</h3>
                    
                </div>
            
            </div>
            </div>
        </section>
<hr />

    </div>
       
        

    )
  }
}
export default NosMissions;


// WEBPACK FOOTER //
// ./src/components/mission.jsx